import { GridColDef } from "@mui/x-data-grid";
import { PricelistPackageType } from "../../../services/orders/pricelist-offers-get-by-id/types";
import {
  FiscalBreakdown,
  StorageAreaPackageType,
  StorageType,
} from "../../../services/storage-area/get/types";
import {
  DistanceUnit,
  PackageType,
  StoragePlace,
  StorageTemperatureCondition,
  WeightUnit,
} from "../../../types/order-form";

export const getTemperatureConditionsEnum = (
  type: StorageTemperatureCondition
) => {
  switch (type) {
    case StorageTemperatureCondition.Nieogrzewany:
      return "Nieogrzewane";
    case StorageTemperatureCondition.Chlodnia:
      return "Chłodnia";
    case StorageTemperatureCondition.Ogrzewanie:
      return "Ogrzewane";
    case StorageTemperatureCondition.TemperatureControl:
      return "Kontrola temperatury";
  }
};

export const getPlaceEnum = (type: StoragePlace) => {
  switch (type) {
    case StoragePlace.Inside:
      return "Wewnątrz";
    case StoragePlace.Outside:
      return "Na zewnątrz";
  }
};

export const getStorageType = (type: StorageType) => {
  switch (type) {
    case StorageType.Flat:
      return "Płaskie";
    case StorageType.High:
      return "Wysokie";
    case StorageType.Shelves:
      return "Półki";
  }
};

export const getFiscalBreakdownEnum = (type: FiscalBreakdown) => {
  switch (type) {
    case FiscalBreakdown.CustomsWarehouse:
      return "Skład celny";
    case FiscalBreakdown.CustomsMagazine:
      return "Magazyn celny";
    case FiscalBreakdown.OrdinaryWarehouse:
      return "Magazyn zwykły";
  }
};
export const getLengthUnitEnum = (type: DistanceUnit) => {
  switch (type) {
    case DistanceUnit.M:
      return "m";
    case DistanceUnit.Cm:
      return "cm";
    case DistanceUnit.Mm:
      return "mm";
  }
};
export const getWeightUnitEnum = (type: WeightUnit) => {
  switch (type) {
    case WeightUnit.Kg:
      return "kg";
    case WeightUnit.Tona:
      return "t";
    case WeightUnit.Dkg:
      return "dkg";
  }
};
export const getPackageTypeEnum = (
  type: StorageAreaPackageType | PricelistPackageType
) => {
  switch (type) {
    case StorageAreaPackageType.Carton || PricelistPackageType.Carton:
      return "Karton";
    case StorageAreaPackageType.BigBag || PricelistPackageType.Bigbag:
      return "BigBag";
    case StorageAreaPackageType.EURPallet || PricelistPackageType.Pallet_EUR:
      return "Paleta EUR";
    case StorageAreaPackageType.HalfEurPallet ||
      PricelistPackageType.Pallet_polowa_EUR:
      return "Paleta 1/2 EUR";
    case StorageAreaPackageType.OtherPallet ||
      PricelistPackageType.Other_pallet:
      return "Inna paleta";
    case StorageAreaPackageType.Other || PricelistPackageType.Other:
      return "Inne";
  }
};
